module.exports = window.ace;